import React from 'react';
import { Shield, Key, EyeOff, HeartHandshake } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-cream section-padding" data-id="element-155">
      <div className="text-center mb-16" data-id="element-156">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-157">
          El Método C.A.S.A.
        </h2>
        <p className="text-xl text-navy font-medium" data-id="element-158">
          Centralizar, Asegurar, Simplificar, Autorizar
        </p>
        <div className="gold-divider" data-id="element-159"></div>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-160">
          No necesitas ser un experto en computación. Este sistema te enseña a
          usar las funciones ocultas que Apple, Google y Facebook ya tienen
          integradas para casos de fallecimiento.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-161">
        <div className="space-y-8" data-id="element-162">
          <div className="flex items-start" data-id="element-163">
            <div className="bg-gold/20 p-3 rounded-full mr-4" data-id="element-164">
              <Key className="w-8 h-8 text-gold-dark" data-id="element-165" />
            </div>
            <div data-id="element-166">
              <h3 className="text-xl font-bold mb-2" data-id="element-167">La "Llave Maestra"</h3>
              <p className="text-gray-600" data-id="element-168">
                Aprenderás a crear una llave que solo se activará cuando tú no
                estés.
              </p>
            </div>
          </div>

          <div className="flex items-start" data-id="element-169">
            <div className="bg-gold/20 p-3 rounded-full mr-4" data-id="element-170">
              <EyeOff className="w-8 h-8 text-gold-dark" data-id="element-171" />
            </div>
            <div data-id="element-172">
              <h3 className="text-xl font-bold mb-2" data-id="element-173">Privacidad Total Hoy</h3>
              <p className="text-gray-600" data-id="element-174">
                Mantén tu privacidad absoluta mientras vivas. Nadie verá tus
                datos ahora.
              </p>
            </div>
          </div>

          <div className="flex items-start" data-id="element-175">
            <div className="bg-gold/20 p-3 rounded-full mr-4" data-id="element-176">
              <HeartHandshake className="w-8 h-8 text-gold-dark" data-id="element-177" />
            </div>
            <div data-id="element-178">
              <h3 className="text-xl font-bold mb-2" data-id="element-179">Transición Fluida</h3>
              <p className="text-gray-600" data-id="element-180">
                Garantiza un proceso sin estrés ni bloqueos para tu familia
                después.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-soft border border-gray-100 text-center relative" data-id="element-181">
          <div className="absolute -top-6 -right-6 bg-gold text-white w-24 h-24 rounded-full flex items-center justify-center font-bold text-lg shadow-lg transform rotate-12" data-id="element-182">
            Fácil y<br data-id="element-183" />
            Rápido
          </div>
          <Shield className="w-24 h-24 text-navy mx-auto mb-6 opacity-20" data-id="element-184" />
          <h3 className="text-2xl font-serif font-bold text-navy-dark mb-4" data-id="element-185">
            Diseñado para ti
          </h3>
          <p className="text-gray-600 text-lg" data-id="element-186">
            Si sabes enviar un mensaje por WhatsApp, tienes todas las
            habilidades técnicas necesarias para implementar este método hoy
            mismo.
          </p>
        </div>
      </div>
    </section>;
}